

















import { Component, Vue } from 'vue-property-decorator';
import { Mutations, Views, ViewModes } from '@/ts/store/Constants';

@Component
export default class MobileOptionsPriceSummary extends Vue {
    constructor() {
        super();
    }

    public selectedItemsPriceSummary() {

        let currentPrice = 0;

        for (const item of this.selectedItem) {
            currentPrice = + item.price;
        }

        return currentPrice;
    }

    public viewYourChoices() {
        this.$store.commit(Mutations.SET_VIEW, {
            view: Views.Options,
                viewMode: ViewModes.Options.YourOptionsView,
            });
    }

    get selectedItem(): any {
        return this.$store.getters['Options/selectedOptions'];
    }

    get view() {
        return this.$store.getters['Viewport/getCurrentView'];
    }

}
